import { computed, ref } from 'vue';

export const SHEET_MIN_ZOOM_PERCENT = 50;
export const SHEET_MAX_ZOOM_PERCENT = 200;
export const SHEET_ZOOM_STEP_PERCENT = 10;

// 100% is the paper fitted to the reading area; the percent multiplies that fit.
export function useSheetZoom() {
  const zoomPercent = ref(100);
  const zoom = computed(() => zoomPercent.value / 100);
  const canZoomOut = computed(() => zoomPercent.value > SHEET_MIN_ZOOM_PERCENT);
  const canZoomIn = computed(() => zoomPercent.value < SHEET_MAX_ZOOM_PERCENT);

  function setZoomPercent(percent: number): void {
    zoomPercent.value = Math.min(SHEET_MAX_ZOOM_PERCENT, Math.max(SHEET_MIN_ZOOM_PERCENT, percent));
  }

  function zoomIn(): void {
    setZoomPercent(zoomPercent.value + SHEET_ZOOM_STEP_PERCENT);
  }

  function zoomOut(): void {
    setZoomPercent(zoomPercent.value - SHEET_ZOOM_STEP_PERCENT);
  }

  function onWheel(event: WheelEvent): void {
    if (!event.ctrlKey && !event.metaKey) return;
    event.preventDefault();
    if (event.deltaY < 0) zoomIn();
    else if (event.deltaY > 0) zoomOut();
  }

  return { zoomPercent, zoom, canZoomIn, canZoomOut, setZoomPercent, zoomIn, zoomOut, onWheel };
}
